import { IItemMetadata } from "../components/list/GenericDataGrid";
import { FieldValue } from "./Field";
import { FieldValues } from "./FieldValues";
import { UserInformation } from "./UserInformation";
import { FlatVsaaTag } from "./VsaaTag";
import { VsaComment } from "./VsaComment";

export interface Tool extends IItemMetadata {
  versionId: string;
  toolId?: string;
  title: string;
  version?: number;
  publishedBy?: UserInformation;
  publishedTimeInUTC?: string;
  isCurrentVersion: boolean;
  comments?: VsaComment[];
  webUrl: string;
  fileName?: string;
  fileType?: string;
  fileUniqueId: string;
  downloadUrl?: string;
  fieldValues?: FieldValues;
  activities?: ActivityToolInformation[];
  chapters?: FlatVsaaTag[];
  adminDisplayName?: string;
}

export interface CreateToolRequest {
  title: string;
  toolId?: string;
  toolType?: string;
  file?: File;
  fileName?: string;
  linkUrl?: string;
  adminDisplayName?: string;
  fieldsWithValues?: Record<string, FieldValue>;
}

export interface UpdateToolsMetadata {
  versionId: string;
  title?: string;
  webUrl?: string;
  fileName?: string;
  fieldsWithValues?: Record<string, FieldValue>;
}

export interface UpdateToolsRequest {
  toolMetadata: UpdateToolsMetadata[];
}

export interface ToolFormData {
  title: string;
  toolType?: string;
  file?: File;
  fileName?: string;
  linkUrl?: string;
  adminDisplayName?: string;
  fieldsWithValues?: Record<string, FieldValue>;
}

export interface PublishToolRequest {
  versionId: string;
  comment: string;
  hiddenComment?: boolean;
}

export interface MassPublishToolRequest {
  versionIds: string[];
  comment: string;
  hiddenComment?: boolean;
}

export interface MassPublishToolResponse {
  results: MassPublishToolResult[];
  successfulCount: number;
  failedCount: number;
  totalCount: number;
}

export interface MassPublishToolResult {
  versionId: string;
  success: boolean;
  title?: string;
  publishedTool?: Tool;
  errorMessage?: string;
  errorCode?: number;
  errorTranslationKey?: string;
}

export interface CreateCloneToolRequest {
  versionId: string;
  oldVersion: boolean;
}

export interface MassCreateToolDraftRequest {
  versionIds: string[];
  oldVersion: boolean;
}

export interface MassCreateToolDraftResponse {
  results: MassCreateToolDraftResult[];
  successfulCount: number;
  failedCount: number;
  totalCount: number;
}

export interface MassCreateToolDraftResult {
  versionId: string;
  success: boolean;
  draftTool?: Tool;
  errorMessage?: string;
  errorCode?: number;
  errorTranslationKey?: string;
}

export interface ActivityToolInformation {
  versionId?: string;
  activityId?: string;
  title?: string;
  publishedBy?: UserInformation;
  publishedTimeInUTC?: string;
  fieldValues?: FieldValues;
  chapters?: FlatVsaaTag[];
}

export enum ToolTypes {
  Document = "Document",
  Link = "Link",
}

export enum FileTypes {
  Word = "Word",
  PowerPoint = "PowerPoint",
}

export interface ActivateToolRequest {
  versionId: string;
  comment: string;
  hiddenComment: boolean;
  setAsActive: boolean;
}

export interface AdminDeleteToolRequest {
  comment: string;
}

export interface DocumentHealthCheckItem {
  itemType: "ToolMissingFile" | "OrphanFile";
  toolId?: string;
  versionId?: string;
  title?: string;
  fileUniqueId?: string;
  isCurrentVersion?: boolean;
  sharePointLibrary?: string;
  spFileUniqueId?: string;
  spWebUrl?: string;
  spFileType?: string;
  spTitle?: string;
  spLibrary?: string;
}

export interface DocumentHealthCheckJobHistory {
  id: string;
  status: number;
  startTime: string;
  endTime?: string;
  triggeredByUserId?: string;
  progress: {
    totalItems: number;
    processedItems: number;
    currentStep: string;
    percentageComplete: number;
  };
  healthCheckItems: DocumentHealthCheckItem[];
}

export interface RelinkToolFileRequest {
  newFileUniqueId: string;
  versionId?: string;
  sharePointLibrary: string;
}
